import React from 'react';
import {Link} from "react-router-dom";
import {observer} from 'mobx-react';
import {withStore} from "../../hocs";
import {IarBreadCrumbs} from '../../interface/IarBreadCrumbs';

// @ts-ignore
@withStore
@observer
export class BreadCrumbs extends React.Component {
    render() {
        // @ts-ignore
        const {store} = this.props;
        const {arBreadCrumbs,onClickBreadCrumbs} = store?.basePageStore;
        return (
            <>
                {arBreadCrumbs.length ?
                        <ul className="breadcrumbs__list">
                            {arBreadCrumbs.map((link: IarBreadCrumbs, index: number) => (
                                <li className="breadcrumbs__item" key={'link-'+link.url}>
                                        <Link onClick={()=>onClickBreadCrumbs(link,index+1)} to={link.url} key={'url' + link.url}>
                                            <span className={index === arBreadCrumbs.length - 1 ? "breadcrumbs__item-text-active" : "breadcrumbs__item-text"}>{link.name}</span>
                                        </Link>
                                </li>))}
                        </ul>
                    : null}
            </>
        );
    }
}


